import { Offcanvas, Form, Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";

interface SectionFormData {
  show: boolean;
  handleClose: () => void;
  data?: any;
}

type FormData = {
  title: string;
  key: string;
  sortOrder: number;
  isActive: boolean;
  description?: string;
};

const AddMembershipSection = ({ show, handleClose, data }: SectionFormData) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>();

  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      reset({
        title: data?.title || "",
        key: data?.key || "",
        sortOrder: data?.sortOrder || 1,
        isActive: data?.isActive ?? true,
        description: data?.description || "",
      });
    } else {
      reset({});
    }
  }, [show, data, reset]);

  const onSubmit = (request: FormData) => {
    setLoading(true);

    const apiCall = data?._id
      ? WebService.putAPI({
          action: `memberShipSections/update/${data._id}`,
          body: request,
        })
      : WebService.postAPI({
          action: `memberShipSections/add`,
          body: request,
        });

    apiCall
      .then((res: any) => {
        toast.success(res.message);
        reset();
        handleClose();
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response?.data?.message || "An error occurred");
      });
  };

  return (
    <Offcanvas
      show={show}
      onHide={() => {
        reset();
        handleClose();
      }}
      placement="end"
      className="offcanvas-custom"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {data ? "Edit Section" : "Add Section"}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Card className="p-3 bg-light my-3 position-relative">
            <span
              className="bg-white position-absolute rounded small"
              style={{ top: "-12px", left: "12px", padding: "0 8px" }}
            >
              Section Details
            </span>

            {/* Title */}
            <Form.Group className="mb-2" controlId="title">
              <Form.Label className="label">
                Title <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter title"
                {...register("title", { required: "Title is required" })}
              />
              {errors.title && (
                <div className="error-message">{errors.title.message}</div>
              )}
            </Form.Group>

            {/* Key */}
            {/* <Form.Group className="mb-2" controlId="key">
              <Form.Label className="label">
                Key <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter key"
                {...register("key", { required: "Key is required" })}
              />
              {errors.key && (
                <div className="error-message">{errors.key.message}</div>
              )}
            </Form.Group> */}

            {/* Sort Order */}
            {/* <Form.Group className="mb-2" controlId="sortOrder">
              <Form.Label className="label">
                Sort Order <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter sort order"
                {...register("sortOrder", {
                  required: "Sort order is required",
                })}
              />
              {errors.sortOrder && (
                <div className="error-message">
                  {errors.sortOrder.message}
                </div>
              )}
            </Form.Group> */}

            {/* Active / Inactive */}
            <Form.Group className="mb-2" controlId="isActive">
              <Form.Label className="label">Status</Form.Label>
              <Form.Select {...register("isActive")}>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </Form.Select>
            </Form.Group>

            {/* Description */}
            <Form.Group className="mb-2" controlId="description">
              <Form.Label className="label">Description</Form.Label>
              <Form.Control
                as="textarea"
                placeholder="Enter description (optional)"
                {...register("description")}
              />
            </Form.Group>
          </Card>
        </Form>
      </Offcanvas.Body>

      <div className="d-flex justify-content-end p-3">
        <CustomButton
          isLoading={isLoading}
          label="Save"
          className="w-100"
          onClick={handleSubmit(onSubmit)}
        />
      </div>
    </Offcanvas>
  );
};

export default AddMembershipSection;
